export default {
  pageTitle: 'Piping Fabrication',
  metaDescription: 'TEF fabricates prefabricated piping spools in titanium, duplex and alloy materials for efficient installation across petrochemical and pharmaceutical plants.',
  sidebar: {
    title: 'Fabrication list',
    vessel: 'Fabrication Vessel',
    heatExchanger: 'Fabrication Heat Exchanger',
    piping: 'Fabrication Piping',
    tower: 'Fabrication Tower',
    muffle: 'Fabrication Muffle',
    radiantTube: 'Fabrication Radiant Tube',
    otherEquipment: 'Fabrication Other Equipment',
  },
  fabricationOf: 'Fabrication of',
  product: {
    name: 'Piping',
    desc: 'The following is a catalog of our experience in Piping fabrication in various types of materials, types and specifications.',
  },
};
